/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_KeyiconInputs */

const en_enum_custom_page_icon_keyicon = /** @type {(inputs: Enum_Custom_Page_Icon_KeyiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key`)
};

const de_enum_custom_page_icon_keyicon = /** @type {(inputs: Enum_Custom_Page_Icon_KeyiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel`)
};

/**
* | output |
* | --- |
* | "Key" |
*
* @param {Enum_Custom_Page_Icon_KeyiconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_keyicon = /** @type {((inputs?: Enum_Custom_Page_Icon_KeyiconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_KeyiconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_keyicon(inputs)
	return de_enum_custom_page_icon_keyicon(inputs)
});